<template>
  <ModalConfirmation
    :data-test-id="dataTestId"
    hasBlur
    :primaryButtonProps="modalContent.primaryButtonProps"
    :showModal="showModal"
    :title="modalContent.title"
    @cancel="handleCancel"
    @close="handleClose"
    @save="handleSave"
  >
    <template v-slot:body>
      <ParagraphBody
        v-for="text in modalContent.text"
        :key="text"
      >
        {{ text }}
      </ParagraphBody>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  ModalConfirmation,
  ParagraphBody,

  Types,
} from '@jumpcloud/ui-components';

const { PrimaryButtonProps } = Types;

export default {
  name: 'ModalMFA',

  components: {
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    dataTestId: {
      type: String,
      default: undefined,
    },
    item: {
      type: Object,
      required: true,
    },
    showModal: Boolean,
    type: {
      type: String,
      default: '',
    },
  },

  computed: {
    modalContent() {
      const { enableMultiFactor, email } = this.item;

      let continueText = 'require MFA';
      let title = 'Require MFA';
      let text = [
        'If you require your administrators to enable Multi-Factor Authentication, they will configure MFA on their next login.',
        'Administrators must have a valid password in order to enroll in MFA.',
        `Are you sure you want to require Multi-factor Authentication for ${email}?`,
      ];

      if (enableMultiFactor) {
        continueText = 'remove MFA';
        title = 'Remove MFA Requirement';
        text = [
          'Removing the Multi-factor Authentication requirement will not clear an existing TOTP token, but the administrator will no longer be required to provide a TOTP token or other second factor mechanism to complete their MFA setup, or verify with MFA login or password resets. Administrators with an existing TOTP token will continue to be prompted for MFA.',
          `Are you sure you want to remove the Multi-factor Authentication requirement for ${email}`,
        ];
      }

      if (this.type === 'reset') {
        continueText = 'reset TOTP';
        title = 'Send TOTP Reset Email';
        text = [
          `Are you sure you want to send TOTP reset email to ${email}?`,
        ];
      }

      return {
        primaryButtonProps: PrimaryButtonProps({
          text: continueText,
        }),
        text,
        title,
      };
    },
  },

  methods: {
    handleCancel() {
      this.$emit('cancel');
    },

    handleClose() {
      this.$emit('close');
    },

    handleSave() {
      this.$emit('save');
    },
  },
};
</script>
